import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

export const GetEmailsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}EmailsWrongRight/GetEmails`,
	hasLoading: true
});

export const AddEmailRequest = (userId, wrongEmail, rightEmail) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}EmailsWrongRight/AddEmail/${userId}`,
	data: { WrongEmail: wrongEmail, RightEmail: rightEmail },
	hasLoading: true
});

export const UpdateEmailRequest = (userId, id, wrongEmail, rightEmail, date) => AxiosRequest({
	method: 'PUT',
	url: `${config.API_URL}EmailsWrongRight/UpdateEmail/${userId}/${id}`,
	data: { Id: id, WrongEmail: wrongEmail, RightEmail: rightEmail, Date: date },
	hasLoading: true
});

export const DeleteEmailRequest = (userId, id) => AxiosRequest({
	method: 'DELETE',
	url: `${config.API_URL}EmailsWrongRight/DeleteEmail/${userId}/${id}`,
	hasLoading: true
});
